import React, { useState, useEffect, useRef } from "react";
import {
  Tooltip,
  Stack,
  Grid,
  MenuItem,
  Checkbox,
  Button,
  Paper,
  Menu,
  Fade,
  ListItemText,
  Select,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextareaAutosize,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import format from "date-fns/format";
import { toast } from "react-toastify";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import FilterListIcon from "@mui/icons-material/FilterList";
import { DataGrid, GridToolbarContainer } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { CommonButton } from "../common/commonButton";
import { useStyles } from "./paymentUpdatesContainerStyles";
import { CommonPaginationContainer, CommonFilterSidebar } from "../common";
import instance from "../../redux/api";
import { exceptionReport } from "../../Services/api";
import "./bdx.css";
import ROUTES from "../../utils/routes";
import ExceptionReportDetails from "./ExceptionReportDetails";
import { getPaginationCount } from "../CashAllocation/utils";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { commonToast } from "../common";
import "../common/commonPageStyles.css";
import {
  primaryButtonStyle,
  primaryButtonHoverColor,
} from "../common/commonButtonStyles";


const options = {
  style: "decimal",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

function handleAmount(val) {
  return (
    (Number(val) && Number(val).toLocaleString("en-US", options)) ||
    (val === 0 && parseInt(val).toFixed(2)) ||
    val
  );
}

const ExceptionReport = () => {
  const { userData } = useSelector((state) => state?.user);
  const [searchFieldsParams, setSearchFieldsParams] = useState({
    certificate_ref: "",
    bdx_file_name: "",
    overall_status: [
      // "Investigate Investigate",
      // "Investigate Initiate Payment",
      // "Investigate Partner Payment Done",
      // "Investigate Payment Fully Done"
    ],
  });

  const [paginationCount, setPaginationCount] = useState(0);

  const toggle = useSelector((state) => state.toggleSideMenu);
  const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [isClearPerformed, setIsClearPerformed] = useState(false);
  const [filterSidebarOpen, setFilterSidebarOpen] = useState(true);

  const [selectedParams, setSelectedParams] = useState({
    type_of_payment: "",
    certificate_ref: "",
    bdx_file_name: "",
  });
  const currentSkipNumber = () => {
    return pageState?.page === 1
      ? 0
      : pageState?.page === 0
        ? pageState?.page
        : pageState?.page - 1;
  };
  const [pageState, setPageState] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 1,
    pageSize: 25,
  });

  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [overallStatuses, setOverallStatuses] = useState([]);
  const openMenu = Boolean(anchorEl);
  const [openCommentsDialog, setOpenCommentsDialog] = useState(null);
  const [currentRowId, setCurrentRowId] = useState(null);
  const [dialogCommentsValue, setDialogCommentsValue] = useState("");
  const [commentType, setCommentType] = useState(null);
  const [openDetailsDialog, setOpenDetailsDialog] = useState(false);

  const isFirstRun = useRef(true);

  useEffect(() => {
    getOverallStatusList();
  }, []);

  //styles
  const classes = useStyles();

  const Container = {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: 0,
    height: "calc(100vh - 180px)",
    maxHeight: "calc(100vh - 180px)",
    overflow: "hidden",
    backgroundColor: "#fafafa",
  };

  useEffect(() => {
    handleSearchPaymentUpdatesList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchFieldsParams.overall_status])


  const getOverallStatusList = async () => {
    const response = await instance.get(
      "payment/payment_overall_status/overall_status/"
    );
    const overall_status_list = response.data.data;
    let selectedOverallStatus = [];
    for (let overall_status of overall_status_list) {
      if (overall_status.toLowerCase().includes("investigate")) {
        selectedOverallStatus.push(overall_status);
      }
    }
    setOverallStatuses(selectedOverallStatus);
    setSearchFieldsParams((old) => ({
      ...old,
      overall_status: selectedOverallStatus,
    }));
  };

  const searchQueryParams = () => {
    let getSearchQueryParams = "";

    const { certificate_ref, bdx_file_name, overall_status } =
      searchFieldsParams;

    if (certificate_ref) {
      getSearchQueryParams = `${getSearchQueryParams}&certificate_ref=${certificate_ref}`;
    }

    if (bdx_file_name) {
      getSearchQueryParams = `${getSearchQueryParams}&bdx_file_name=${bdx_file_name}`;
    }

    if (overall_status?.length) {
      const overallStatusStr = overall_status.join(",");
      getSearchQueryParams = `${getSearchQueryParams}&overall_status=${overallStatusStr}`;
    }

    return getSearchQueryParams;
  }

  const handleSearchPaymentUpdatesList = async () => {
    try {
      let queryParams = `?skip=0&pageSize=${pageState?.pageSize}`;

      const getSearchQueryParam = searchQueryParams();
      if (getSearchQueryParam) {
        queryParams = `${queryParams}${getSearchQueryParam}`;
      }

      // set loading indicator
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));

      const response = await instance.get(`${exceptionReport}${queryParams}`);

      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      setIsSearchPerformed(true);
      setIsClearPerformed(false);

      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
          page: 1,  // required for sending skip as 0
        }));
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: [],
        }));
        setPaginationCount(0);
      }
    } catch (error) {
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));
      setPaginationCount(0);
      console.log("error", error);
    }
  };

  const handleClearSearchList = async () => {
    setIsSearchPerformed(false);
    setIsClearPerformed(true);

    // clear fields
    setSearchFieldsParams({
      certificate_ref: "",
      bdx_file_name: "",
      overall_status: [],
    });
  };

  const isFilterBtnDisable = () => {
    let disabled = true;
    const { certificate_ref, bdx_file_name, overall_status } =
      searchFieldsParams;
    if (
      certificate_ref !== "" ||
      bdx_file_name !== "" ||
      overall_status.length
    ) {
      disabled = false;
    }
    return disabled;
  };

  const loadData = async () => {
    try {
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));

      let investigate_str = "";
      let queryParams = ``;
      if (searchFieldsParams.overall_status.length) {
        const overallStatusStr = searchFieldsParams.overall_status.join(",");
        queryParams = `${queryParams}&overall_status=${overallStatusStr}`;
      } else if (isFirstRun.current) {
        investigate_str = "investigate";
        queryParams = `&overall_status_contains=${investigate_str}`;
        isFirstRun.current = false;
      }
      // add search query param if the search is enabled
      if (isSearchPerformed) {
        const getSearchQueryParam = searchQueryParams();
        if (getSearchQueryParam) {
          queryParams = `${queryParams}${getSearchQueryParam}`;
        }
      }

      const response = await instance.get(
        `${exceptionReport}?skip=${currentSkipNumber()}&pageSize=${pageState?.pageSize
        }${queryParams}`
      );

      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
        }));
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: [],
        }));
        setPaginationCount(0);
      }
    } catch (err) {
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));
      setPaginationCount(0);
      console.error("err", err);
    }
  };

  const handleCloseMenu = (index) => {
    setAnchorEl(null);
  };

  const handleClickMenu = (event, params) => {
    setSelectedParams((old) => ({
      ...old,
      certificate_ref: params?.certificate_ref,
      bdx_file_name: params?.bdx_file_name,
      type_of_payment: params?.cash_bank_ref,
    }));
    setAnchorEl(event.currentTarget);
  };

  const handleCheckboxChange = (event, index) => {
    if (event.target.checked) {
      setSelectedRowIndex(index);
      setOpenDetailsDialog(true);
    } else {
      setSelectedRowIndex(null);
      setOpenDetailsDialog(false);
    }
  };


  const getTreasurySearchPrams = () => {
    let searchParam = "";

    if (selectedParams?.certificate_ref) {
      searchParam = `${searchParam}policyNo=${selectedParams?.certificate_ref}`;
    }
    // if (selectedParams?.bdx_file_name) {
    //   searchParam = `${searchParam}&fileName=${selectedParams?.bdx_file_name.replace("&", "%26")}`;
    // }
    // if (selectedParams?.type_of_payment) {
    //   searchParam = `${searchParam}&paymentType=${selectedParams?.type_of_payment}`;
    // }

    return searchParam;
  }

  const PremiumBDXSearchPrams = () => {
    let searchParam = "";

    if (selectedParams?.certificate_ref) {
      searchParam = `${searchParam}policyNo=${selectedParams?.certificate_ref}`;
    }
    if (selectedParams?.bdx_file_name) {
      searchParam = `${searchParam}&fileName=${selectedParams?.bdx_file_name.replace("&", "%26")}`;
    }
    return searchParam;
  }

  const columns = [
    {
      headerName: "",
      headerAlign: "center",
      width: 60,
      type: "actions",
      renderCell: (params) => (
        <>
          <Checkbox
            className="table-checkbox"
            checked={selectedRowIndex === params.api.getRowIndex(params.row.id)}
            onChange={(event) =>
              handleCheckboxChange(event, params.api.getRowIndex(params.row.id))
            }
            sx={{
              color: "#1672DE",
              "&.Mui-checked": {
                color: "#1672DE",
              },
            }}
          />
        </>
      ),
    },
    {
      field: "certificate_ref",
      headerName: "Certificate Ref",
      headerAlign: "center",
      headerClassName: "hide-column",
      width: 160,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{}}>{params.row.certificate_ref}</div>
          <Button
            onClick={(event) => handleClickMenu(event, params.row)}
            endIcon={<KeyboardArrowDownIcon style={{ fill: "black" }} />}
            style={{ minWidth: "20px", background: "transparent" }}
          />
          <Paper>
            <Menu
              anchorEl={anchorEl}
              open={openMenu}
              onClose={handleCloseMenu}
              TransitionComponent={Fade}
            >
              <MenuItem onClick={{}} style={{ color: "black" }}>
                <Link
                  to={{
                    pathname: ROUTES.MUCASHTRACKER,
                    search: `?policyNo=${selectedParams.certificate_ref}`,
                  }}
                  target={"_blank"}
                  style={{ color: "black" }}
                >
                  Cash Tracker
                </Link>
              </MenuItem>
              <MenuItem onClick={{}}>
                <Link
                  to={{
                    pathname: ROUTES.TreasuryList,
                    search: `?${getTreasurySearchPrams()}`,
                  }}
                  target={"_blank"}
                  style={{ color: "black" }}
                >
                  Treasury
                </Link>
              </MenuItem>
              <MenuItem onClick={{}}>
                <Link
                  to={{
                    pathname: ROUTES.PremiumBDX,
                    search: `?${PremiumBDXSearchPrams()}`,
                  }}
                  params={{
                    policyNo: params.row.certificateRef,
                    fileName: params.row.bdx_file_name,
                  }}
                  target={"_blank"}
                  style={{ color: "black" }}
                >
                  Premium BDX
                </Link>
              </MenuItem>
            </Menu>
          </Paper>
        </div>
      ),
    },
    {
      field: "bdx_file_name",
      headerName: "BDX File Name",
      headerAlign: "center",
      width: 500,
      renderCell: (params) => (
        <div>
          <Tooltip title={params.row.bdx_file_name}>
            {params.row?.bdx_file_name.length > 100 
                ? `${params.row.bdx_file_name.substring(0, 100)}...` 
                : params.row.bdx_file_name}
          </Tooltip>
        </div>
      ),
    },
    {
      field: "created_at",
      headerName: "Created Date",
      headerAlign: "center",
      width: 170,
      valueFormatter: (params) => {
        return format(new Date(params.value), "dd-MM-yyyy");
      },
    },
    {
      field: "settlement_currency",
      headerName: "Settlement Ccy",
      headerAlign: "center",
      width: 130
    },
    {
      field: "net_of_brokerage",
      headerName: "Net of Brokerage",
      headerAlign: "center",
      width: 130,
      cellClassName: "amount-table-cell",
      renderCell: (params) => <>{handleAmount(params.row.net_of_brokerage)}</>,
    },
    {
      field: "net_premium",
      headerName: "Net Premium",
      headerAlign: "center",
      width: 110,
      cellClassName: "amount-table-cell",
      renderCell: (params) => <>{handleAmount(params.row.net_premium)}</>,
    },
    {
      field: "ct_allocation_amt",
      headerName: "CT Allocation Amt",
      headerAlign: "center",
      width: 135,
      cellClassName: "amount-table-cell",
      renderCell: (params) => <>{handleAmount(params.row.ct_allocation_amt)}</>,
    },
    {
      field: "variance_with_ct",
      headerName: "Variance with CT",
      headerAlign: "center",
      width: 130,
      cellClassName: "amount-table-cell",
      renderCell: (params) => <>{handleAmount(params.row.variance_with_ct)}</>,
    },
    {
      field: "overall_status",
      headerName: "Overall Status",
      headerAlign: "center",
      width: 160,
      cellClassName: "overall-status-cell",
      renderCell: (params) => (
        <div>
          <Tooltip title={params.row?.overall_status}>
            {params.row?.overall_status}
          </Tooltip>
        </div>
      ),
    },
    {
      field: "cash_bdx_amt",
      headerName: "Cash BDx Amt",
      headerAlign: "center",
      width: 115,
      cellClassName: "amount-table-cell",
      renderCell: (params) => <>{handleAmount(params?.row?.cash_bdx_amt)}</>
    },
    {
      field: "non_cash_bdx_amt",
      headerName: "Non Cash BDx Amt",
      headerAlign: "center",
      width: 140,
      cellClassName: "amount-table-cell",
      renderCell: (params) => <>{handleAmount(params?.row?.non_cash_bdx_amt)}</>
    },

    {
      field: "potential_payment_indicator",
      headerName: "Potential Payment Indicator",
      headerAlign: "center",
      width: 170,
    },
    {
      field: "comments_audit",
      headerName: "Comments - Audit",
      headerAlign: "center",
      width: 140,
      renderCell: (params) => (
        <>
          {params?.row?.comments_audit?.substr(0, 15) ?? ""}
          <div>
            <MoreHorizIcon
              onClick={() =>
                handleCommentsOpenDialog(
                  params?.row?.id,
                  params?.row?.comments_audit,
                  "comments_audit"
                )
              }
            />
          </div>
        </>
      ),
    },
    {
      field: "comment",
      headerName: "Comment",
      headerAlign: "center",
      width: 120,
      renderCell: (params) => (
        <>
          {params?.row?.comment?.substr(0, 15) ?? ""}
          <div>
            <MoreHorizIcon
              onClick={() =>
                handleCommentsOpenDialog(
                  params?.row?.id,
                  params?.row?.comment,
                  "comment"
                )
              }
            />
          </div>
        </>
      ),
    },
  ];


  useEffect(() => {
    setPaginationCount(getPaginationCount(pageState?.total, pageState?.pageSize));
  }, [pageState?.pageSize, pageState?.total]);

  // UseEffect
  useEffect(() => {
    if (isClearPerformed) {
      loadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isClearPerformed]);

  useEffect(() => {
    if (!isClearPerformed) {
      loadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageState?.pageSize, pageState?.page]);

  const handleCommentsOpenDialog = (currentRowId, currentRowCommentData, commentType) => {
    setOpenCommentsDialog(true);
    setCurrentRowId(currentRowId);
    setDialogCommentsValue(currentRowCommentData);
    setCommentType(commentType);
  };

  const handleCloseCommentDialog = () => {
    setOpenCommentsDialog(false);
    setDialogCommentsValue("");
    setCurrentRowId(null);
    setCommentType(null);
  };

  const handleDialogInputChange = (e) => {
    setDialogCommentsValue(e.target.value);
  };

  const handleSaveComments = () => {
    if (commentType === "comment") {
      handleCommentsUpdate();
    }
    else if (commentType === "comments_audit") {
      handleAuditCommentsUpdate();
    }
    handleCloseCommentDialog();
  };

  const handleCommentsUpdate = async () => {
    const payload = {
      updated_by: userData.id,
      comment: dialogCommentsValue,
    };
    const response = await instance.patch(
      `/payment/exception_file/${currentRowId}/`,
      payload
    );
    if (response.status === 200) {
      commonToast("success", "Comment successfully saved");
      loadData();
    } else {
      commonToast("error", "Comment could not be saved");
    }
  };

  const handleAuditCommentsUpdate = async () => {
    const payload = {
      updated_by: userData.id,
      comments_audit: dialogCommentsValue,
    };
    const response = await instance.patch(
      `/payment/exception_file/${currentRowId}/`,
      payload
    );
    if (response.status === 200) {
      commonToast("success", "Audit Comment successfully saved");
      loadData();
    } else {
      commonToast("error", "Audit Comment could not be saved");
    }
  };

  const handleEnter = (e) => {
    if (e.code === "Enter") {
      handleSearchPaymentUpdatesList();
    }
  };

  // Prepare filter configs for CommonFilterSidebar
  const filterConfigs = [
    {
      type: "textInput",
      label: "Certificate Ref",
      placeholder: "Type certificate ref",
      value: searchFieldsParams.certificate_ref,
      onChange: (value) => {
        if (!value) {
          handleClearSearchList();
        }
        setSearchFieldsParams((v) => ({
          ...v,
          certificate_ref: value,
        }));
      },
      onKeyUp: handleEnter,
    },
    {
      type: "textInput",
      label: "BDX File Name",
      placeholder: "Type bdx file name",
      value: searchFieldsParams.bdx_file_name,
      onChange: (value) => {
        if (!value) {
          handleClearSearchList();
        }
        setSearchFieldsParams((v) => ({
          ...v,
          bdx_file_name: value,
        }));
      },
      onKeyUp: handleEnter,
    },
    {
      type: "custom",
      content: (
        <>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#000",
              marginBottom: "12px",
                }}
              >
                Overall Status
          </Typography>
              <Select
            fullWidth
            size="small"
                name="overall_status"
                multiple
                value={searchFieldsParams.overall_status}
            onChange={(e) => {
              const value = e.target.value;
              if (!value || value.length === 0) {
                handleClearSearchList();
              }
              setSearchFieldsParams((v) => ({
                ...v,
                overall_status: value,
              }));
            }}
            renderValue={(selected) => 
              selected.length > 0 
                ? selected.join(", ").substring(0, 30) + (selected.join(", ").length > 30 ? "..." : "")
                : "Select Overall Status"
            }
            sx={{
              color: "#000000",
              "& .MuiOutlinedInput-root": {
                borderRadius: "4px",
                color: "#000000",
                "& fieldset": {
                  borderColor: "#d0d0d0",
                },
                "&:hover fieldset": {
                  borderColor: "#1672DE",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#1672DE",
                },
              },
              "& .MuiSelect-icon": {
                color: "#1672DE",
              },
              "& .MuiInputBase-input": {
                color: "#000000",
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  "& .MuiMenuItem-root": {
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.08)",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "rgba(22, 114, 222, 0.12)",
                      "&:hover": {
                        backgroundColor: "rgba(22, 114, 222, 0.16)",
                      },
                    },
                  },
                },
              },
            }}
              >
                {overallStatuses.map((name) => (
              <MenuItem 
                key={name} 
                value={name}
                sx={{
                  color: "#000000",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.08)",
                    color: "#000000",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "rgba(22, 114, 222, 0.12)",
                    color: "#000000",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.16)",
                      color: "#000000",
                    },
                  },
                }}
              >
                    <Checkbox
                  checked={searchFieldsParams?.overall_status?.indexOf(name) > -1}
                  sx={{
                    color: "#1672DE",
                    "&.Mui-checked": {
                      color: "#1672DE",
                    },
                  }}
                />
                <ListItemText 
                  primary={name}
                  primaryTypographyProps={{
                    sx: {
                      color: "#000000",
                    },
                  }}
                />
                  </MenuItem>
                ))}
              </Select>
        </>
      ),
    },
  ];

  return (
    <div style={Container}>
      {/* Filter Sidebar */}
      <CommonFilterSidebar
        isOpen={filterSidebarOpen}
        filterConfigs={filterConfigs}
        onApplyFilters={handleSearchPaymentUpdatesList}
        onClearFilters={handleClearSearchList}
        isLoading={pageState?.isLoading}
        isFilterDisabled={isFilterBtnDisable()}
      />

      {/* Main Content Area */}
      <Box className="main-content-area">
        <Box className="page-header-container">
          <Typography
            variant="h5"
            className="page-heading"
          >
            Exception Report
          </Typography>
          <Box sx={{ display: "flex", gap: "12px", alignItems: "center" }}>
            <IconButton
              onClick={() => setFilterSidebarOpen(!filterSidebarOpen)}
              className="filter-toggle-button"
            >
              <FilterListIcon />
            </IconButton>
          </Box>
        </Box>

        <Box
          sx={{
            flex: 1,
          display: "flex",
            flexDirection: "column",
            minHeight: 0,
            position: "relative",
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
            overflow: "visible",
            transition: "all 0.3s ease",
            border: "1px solid #e8eaf0",
            paddingBottom: "10px",
            "&:hover": {
              boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
            },
        }}
      >
        <DataGrid
          className={classes.pagination}
          loading={pageState?.isLoading}
          rows={pageState?.data ?? []}
          getRowId={(row) => row?.id}
          rowCount={pageState?.total}
          columns={columns}
          keepNonExistentRowsSelected
          pagination
          paginationMode="server"
          disableSelectionOnClick
          page={pageState.page - 1}
          pageSize={pageState?.pageSize ?? 25}
            rowsPerPageOptions={[10, 25, 50, 100]}
          onPageSizeChange={(newPageSize) => {
            return setPageState((old) => {
              setPaginationCount(getPaginationCount(pageState?.total, newPageSize))
              return { ...old, pageSize: newPageSize, page: 1 };
            });
          }}
          sx={{
              border: "none",
              flex: 1,
              minHeight: 0,
              "& .MuiDataGrid-root": {
                border: "none",
                height: "100%",
              },
              "& .MuiDataGrid-main": {
                height: "100%",
                "&::-webkit-scrollbar": {
                  width: "8px",
                  height: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#1672DE",
                  borderRadius: "10px",
                  "&:hover": {
                    background: "#1565c0",
                  },
                },
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f8f9fa",
                borderBottom: "2px solid #e0e0e0",
                minHeight: "52px !important",
                maxHeight: "52px !important",
              },
              "& .MuiDataGrid-columnHeader": {
                backgroundColor: "transparent",
                fontWeight: "600",
                color: "#1672DE",
                fontSize: "14px",
                padding: "12px 16px",
                borderBottom: "none",
                "&:focus": {
                  outline: "none",
                },
                "&:focus-within": {
                  outline: "none",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "600",
                  fontSize: "14px",
                },
                "& .MuiDataGrid-sortIcon": {
                  color: "#1672DE",
                },
                "& .MuiDataGrid-menuIcon": {
                  color: "#1672DE",
                },
              },
              "& .MuiDataGrid-row": {
                transition: "all 0.2s ease",
                borderBottom: "1px solid #f0f0f0",
                "&:hover": {
                  backgroundColor: "rgba(22, 114, 222, 0.04)",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                },
                "&.Mui-selected": {
                  backgroundColor: "rgba(22, 114, 222, 0.08)",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.12)",
                  },
                },
                "&:nth-of-type(even)": {
                  backgroundColor: "#fafafa",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.04)",
                  },
                },
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "1px solid #f0f0f0",
                padding: "12px 16px",
                fontSize: "13px",
                color: "#333",
                display: "flex",
                alignItems: "center",
                "&:focus": {
                  outline: "none",
                },
                "&:focus-within": {
                  outline: "none",
                },
              },
              "& .MuiDataGrid-virtualScroller": {
                "&::-webkit-scrollbar": {
                  width: "8px",
                  height: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#1672DE",
                  borderRadius: "10px",
                  "&:hover": {
                    background: "#1565c0",
                  },
                },
              },
              "& .MuiDataGrid-footerContainer": {
                borderTop: "2px solid #e0e0e0",
                backgroundColor: "#f8f9fa",
                minHeight: "48px",
                maxHeight: "48px",
                paddingBottom: "8px",
                paddingTop: "8px",
                paddingLeft: "16px",
                paddingRight: "16px",
                position: "relative",
                zIndex: 1,
                "& .MuiTablePagination-root": {
                  color: "#666",
                  paddingRight: "16px",
                  margin: 0,
                  minHeight: "32px",
                },
                "& .MuiTablePagination-selectLabel": {
                  fontSize: "13px",
                  margin: 0,
                },
                "& .MuiTablePagination-displayedRows": {
                  fontSize: "13px",
                  margin: 0,
                },
                "& .MuiTablePagination-actions": {
                  marginLeft: "8px",
                  "& .MuiIconButton-root": {
                    padding: "4px",
                  },
                },
                "& .MuiTablePagination-select": {
                  margin: "0 8px",
                  padding: "4px 8px",
                },
                "& .MuiTablePagination-toolbar": {
                  minHeight: "32px",
                  padding: 0,
                },
              },
              "& .MuiDataGrid-toolbarContainer": {
                padding: "12px 16px",
                backgroundColor: "#f8f9fa",
                borderBottom: "1px solid #e0e0e0",
                "& .MuiButton-root": {
                  color: "#1672DE",
                  fontSize: "13px",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.1)",
                  },
                },
              },
              "& .MuiDataGrid-loadingOverlay": {
                backgroundColor: "rgba(255, 255, 255, 0.8)",
            },
          }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
            },
          }}
          components={{
            Toolbar: GridToolbarContainer,
            NoRowsOverlay: () => (
                <Stack
                  height="100%"
                  alignItems="center"
                  justifyContent="center"
                  sx={{ color: "#999" }}
                >
                  <Typography variant="body2" sx={{ color: "#999" }}>
                No Uploaded Files
                  </Typography>
              </Stack>
            ),
          }}
        />
        <Stack
            sx={{
            position: "absolute",
              bottom: "16px",
              right: "20px",
              zIndex: 10,
              backgroundColor: "#f8f9fa",
              padding: "4px 8px",
              borderRadius: "4px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <CommonPaginationContainer
            count={paginationCount + 1}
            pageState={pageState}
            setPageState={setPageState}
          />
        </Stack>
        </Box>
      </Box>

      <Dialog open={openCommentsDialog} onClose={handleCloseCommentDialog}>
        <DialogTitle>{commentType === "comment" ? "Comment" : commentType === "comments_audit" ? "Comments - Audit" : ""}</DialogTitle>
        <DialogContent sx={{ overflow: "hidden", textAlign: "center" }}>
          <TextareaAutosize
            minRows={5}
            value={dialogCommentsValue}
            onChange={handleDialogInputChange}
            className=""
            style={{ width: "350px", minWidth: "350px" }}
          />
        </DialogContent>

        <DialogActions>
          <CommonButton
            text="Cancel"
            handleClick={handleCloseCommentDialog}
            style={{
              backgroundColor: "#ffffff",
              color: "#000000",
              border: "1px solid #BCBDBF",
              borderRadius: "6px",
              padding: "8px 16px",
              fontWeight: "500",
            }}
          />
          <CommonButton
            text="Save"
            handleClick={handleSaveComments}
            sx={primaryButtonStyle}
            hoverColor={primaryButtonHoverColor}
            disabled={!dialogCommentsValue}
          />
        </DialogActions>
      </Dialog>

      {/* Exception Report Details Dialog */}
      <Dialog 
        open={openDetailsDialog} 
        onClose={() => {
          setOpenDetailsDialog(false);
          setSelectedRowIndex(null);
        }}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "8px",
            maxHeight: "90vh",
          },
        }}
      >
        <DialogTitle sx={{ 
          fontSize: "20px", 
          fontWeight: "600", 
          color: "#000",
          paddingBottom: "12px",
          borderBottom: "1px solid #e0e0e0",
          backgroundColor: "#f8f9fa",
        }}>
          Exception Report Details
        </DialogTitle>
        <DialogContent sx={{ 
          paddingTop: "20px", 
          paddingBottom: "20px",
          maxHeight: "70vh",
          overflowY: "auto",
        }}>
          {selectedRowIndex != null && pageState?.data[selectedRowIndex] && (
            <ExceptionReportDetails record={pageState?.data[selectedRowIndex]} />
          )}
        </DialogContent>
        <DialogActions sx={{ padding: "16px 24px", borderTop: "1px solid #e0e0e0" }}>
          <CommonButton
            text="Close"
            handleClick={() => {
              setOpenDetailsDialog(false);
              setSelectedRowIndex(null);
            }}
            sx={primaryButtonStyle}
            hoverColor={primaryButtonHoverColor}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ExceptionReport;
